export default {"src":"/_next/static/media/active-directory.bdaa447b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};